export default {"src":"/_next/static/media/test-info.4eb7ad92.gif","height":1472,"width":2616,"blurWidth":0,"blurHeight":0};